import styled, { css } from "styled-components";
import * as colors from "../settings/colors";

const muted = ({ muted }) => muted && css`color: ${colors.TEXT_TERTIARY};`;

const Text = styled.span`
  line-height: 1.5;
  ${muted};
`;

export const P = Text.withComponent("div").extend`
  margin: 1em 0;
`;

export const Price = Text.extend`
  color: ${colors.RED};
  font-weight: 700;
`;

export default Text;



// WEBPACK FOOTER //
// ./src/components/Text.js